import angular from 'angular';
import $ from 'jquery';

export const repositionItem = (array, oldIndex, newIndex) => {
  var current = (array || []).slice();
  var moved = current.splice(oldIndex, 1)[0];
  current.splice(newIndex, 0, moved);
  return current;
};

angular.module('cloudX').directive('cxSortableTags', [
  '$timeout',
  '$parse',
  function($timeout, $parse) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) return;
        var $ul;

        var initTimer = $timeout(function() {
          var ul = element[0].querySelector('ul.tag-list');
          if (!ul) return;
          $ul = $(ul);
          $ul.sortable({
            items: '> li.tag-item',
            axis: 'y',
            cursor: 'move',
            forcePlaceholderSize: true,
            placeholder: 'sortable-placeholder',
            start: function(event, ui) {
              ui.item.data('cxOldIndex', ui.item.index());
            },
            update: function(event, ui) {
              var oldIndex = ui.item.data('cxOldIndex');
              var newIndex = ui.item
                .parent()
                .children('li.tag-item')
                .index(ui.item);
              if (oldIndex == null || newIndex < 0 || oldIndex === newIndex) return;
              $timeout(function() {
                const newArray = repositionItem(ngModel.$modelValue, oldIndex, newIndex);
                ngModel.$setViewValue(newArray);
                ngModel.$validate();

                if (attrs.cxSortableTags) {
                  scope.$eval(attrs.cxSortableTags, { $from: oldIndex, $to: newIndex });
                }
              }, 100);
            },
          });
        });

        scope.$on('$destroy', function() {
          $timeout.cancel(initTimer);
          if ($ul && $ul.data('ui-sortable')) $ul.sortable('destroy');
        });
      },
    };
  },
]);
